module.exports = __webpack_public_path__ + "img/sack_right.1e3ec0ef.jpg";